import { Controller } from "stimulus"

// Auto-fills province select based on Spanish postal code
// Compatible with Stimulus v1.x
export default class extends Controller {
  static targets = ["postalCodeWrapper", "provinceWrapper", "countryWrapper"]

  connect() {
    // Parse provinces data from the data attribute (Stimulus v1 doesn't have values API)
    const provincesJson = this.data.get("provinces")
    this.provinces = provincesJson ? JSON.parse(provincesJson) : {}

    if (!this.hasPostalCodeWrapperTarget || !this.hasProvinceWrapperTarget || !this.hasCountryWrapperTarget) {
      return
    }

    this.postalCodeInput = this.postalCodeWrapperTarget.querySelector("input")
    if (!this.postalCodeInput) return

    this.boundHandler = this.handlePostalCodeChange.bind(this)
    this.postalCodeInput.addEventListener("input", this.boundHandler)
  }

  disconnect() {
    if (this.postalCodeInput && this.boundHandler) {
      this.postalCodeInput.removeEventListener("input", this.boundHandler)
    }
  }

  handlePostalCodeChange() {
    const postalCode = this.postalCodeInput.value

    const countrySelect = this.countryWrapperTarget.querySelector("select")
    if (!countrySelect) return

    // Get country value - check TomSelect first, then native select
    const countryCode = countrySelect.tomselect
      ? countrySelect.tomselect.getValue()
      : countrySelect.value

    // Only auto-fill for Spanish postal codes
    if (countryCode !== "ES") return

    // Spanish postal codes are 5 digits, need at least 2 to determine province
    if (postalCode.length < 2) return

    const prefix = postalCode.substring(0, 2)
    const provinceName = this.provinces[prefix]

    if (provinceName) {
      this.setProvinceValue(provinceName)
    }
  }

  setProvinceValue(provinceName) {
    const provinceSelect = this.provinceWrapperTarget.querySelector("select")
    if (!provinceSelect) return

    if (provinceSelect.tomselect) {
      provinceSelect.tomselect.setValue(provinceName, true)
    } else {
      provinceSelect.value = provinceName
    }
  }
}
